var SurfaceVariants = /* @__PURE__ */ ((SurfaceVariants2) => {
  SurfaceVariants2["hard_court"] = "hard_court";
  SurfaceVariants2["grass"] = "grass";
  SurfaceVariants2["sand"] = "sand";
  SurfaceVariants2["red_clay"] = "red_clay";
  SurfaceVariants2["green_clay"] = "green_clay";
  SurfaceVariants2["hardcourt_outdoor"] = "hardcourt_outdoor";
  SurfaceVariants2["carpet_indoor"] = "carpet_indoor";
  SurfaceVariants2["synthetic_indoor"] = "synthetic_indoor";
  SurfaceVariants2["synthetic_outdoor"] = "synthetic_outdoor";
  SurfaceVariants2["synthetic_grass"] = "synthetic_grass";
  SurfaceVariants2["hardcourt_indoor"] = "hardcourt_indoor";
  SurfaceVariants2["red"] = "red";
  SurfaceVariants2["clay"] = "clay";
  SurfaceVariants2["indoor"] = "indoor";
  return SurfaceVariants2;
})(SurfaceVariants || {});
var BetRadarSocketTypes = /* @__PURE__ */ ((BetRadarSocketTypes2) => {
  BetRadarSocketTypes2["ended"] = "event-ended";
  BetRadarSocketTypes2["close"] = "event-closed";
  BetRadarSocketTypes2["startLive"] = "event-start-live";
  BetRadarSocketTypes2["eventStopped"] = "event-stopped";
  BetRadarSocketTypes2["eventSportStatusChanged"] = "event-sport-status-changed";
  BetRadarSocketTypes2["eventTipsAdded"] = "event-tips-added";
  BetRadarSocketTypes2["eventTipsChanged"] = "event-tips-changed";
  BetRadarSocketTypes2["eventTipsTranslationAdded"] = "event-tips-translation-added";
  BetRadarSocketTypes2["eventTipsTranslationChanged"] = "event-tips-translation-changed";
  BetRadarSocketTypes2["betStop"] = "bet-stop";
  BetRadarSocketTypes2["odds"] = "odds-change";
  BetRadarSocketTypes2["aliveStop"] = "feed-is-down";
  BetRadarSocketTypes2["aliveStart"] = "feed-is-up";
  BetRadarSocketTypes2["betSettlement"] = "bet-settlement";
  BetRadarSocketTypes2["betCancel"] = "bet-cancel";
  BetRadarSocketTypes2["betRollBackCancel"] = "rollback-bet-cancel";
  BetRadarSocketTypes2["couponState"] = "coupon-status";
  BetRadarSocketTypes2["eventChanged"] = "event-changed";
  BetRadarSocketTypes2["liveOddsEnabled"] = "live-odds-enabled";
  BetRadarSocketTypes2["liveOddsDisabled"] = "live-odds-disabled";
  BetRadarSocketTypes2["liveBetsEnabled"] = "live-bets-enabled";
  BetRadarSocketTypes2["liveBetsDisabled"] = "live-bets-disabled";
  BetRadarSocketTypes2["broadcastAdded"] = "event-broadcast-added";
  BetRadarSocketTypes2["broadcastUpdated"] = "event-broadcast-updated";
  BetRadarSocketTypes2["broadcastEnabled"] = "event-broadcast-enabled";
  BetRadarSocketTypes2["broadcastDisabled"] = "event-broadcast-disabled";
  BetRadarSocketTypes2["broadcastRemoved"] = "event-broadcast-removed";
  BetRadarSocketTypes2["cashouts"] = "bet-cashout";
  BetRadarSocketTypes2["comboBoost"] = "combo-boost-status";
  BetRadarSocketTypes2["accountBalanceChange"] = "account-balance-changed";
  BetRadarSocketTypes2["userBonusIssued"] = "user-bonus-issued";
  BetRadarSocketTypes2["userGameBonusBuyIssued"] = "user-game-bonus-buy-issued";
  BetRadarSocketTypes2["userBonusStageChanges"] = "user-bonus-stage-changed";
  BetRadarSocketTypes2["userGameBonusBuyStageChanges"] = "user-game-bonus-buy-stage-changed";
  BetRadarSocketTypes2["bonusWagerChanged"] = "bonus-wager-changed";
  BetRadarSocketTypes2["bonusCredited"] = "bonus-credited";
  BetRadarSocketTypes2["freeBetIssued"] = "free-bet-issued";
  BetRadarSocketTypes2["freeBetStageChanged"] = "free-bet-stage-changed";
  BetRadarSocketTypes2["freeSpinsStageChanged"] = "free-spins-stage-changed";
  BetRadarSocketTypes2["freeSpinsIssued"] = "free-spin-issued";
  BetRadarSocketTypes2["riskFreeBetIssued"] = "user-risk-free-bet-issued";
  BetRadarSocketTypes2["forecastUpdated"] = "sport-forecast-updated";
  BetRadarSocketTypes2["forecastProbabilitiesUpdated"] = "sport-forecast-probabilities-updated";
  return BetRadarSocketTypes2;
})(BetRadarSocketTypes || {});
var RoundTypes = /* @__PURE__ */ ((RoundTypes2) => {
  RoundTypes2["UNKNOWN"] = "unknown";
  RoundTypes2["CUP"] = "cup";
  RoundTypes2["GROUP"] = "group";
  RoundTypes2["QUALIFICATION"] = "qualification";
  return RoundTypes2;
})(RoundTypes || {});
var SportType = /* @__PURE__ */ ((SportType2) => {
  SportType2[SportType2["baseSport"] = 0] = "baseSport";
  SportType2[SportType2["races"] = 1] = "races";
  SportType2[SportType2["cyberSport"] = 2] = "cyberSport";
  return SportType2;
})(SportType || {});
var LeaguePageSections = /* @__PURE__ */ ((LeaguePageSections2) => {
  LeaguePageSections2["league"] = "league";
  LeaguePageSections2["outrights"] = "outrights";
  return LeaguePageSections2;
})(LeaguePageSections || {});
var EventTypesMap = /* @__PURE__ */ ((EventTypesMap2) => {
  EventTypesMap2["line"] = "0";
  EventTypesMap2["live"] = "1";
  return EventTypesMap2;
})(EventTypesMap || {});
var SearchTabs = /* @__PURE__ */ ((SearchTabs2) => {
  SearchTabs2["EVENTS"] = "events";
  SearchTabs2["LEAGUES"] = "leagues";
  SearchTabs2["SPORTS"] = "sports";
  return SearchTabs2;
})(SearchTabs || {});
var BetRadarEntityStatus = /* @__PURE__ */ ((BetRadarEntityStatus2) => {
  BetRadarEntityStatus2[BetRadarEntityStatus2["active"] = 1] = "active";
  BetRadarEntityStatus2[BetRadarEntityStatus2["inActive"] = 0] = "inActive";
  BetRadarEntityStatus2[BetRadarEntityStatus2["suspended"] = -1] = "suspended";
  return BetRadarEntityStatus2;
})(BetRadarEntityStatus || {});
var FeedVendorType = /* @__PURE__ */ ((FeedVendorType2) => {
  FeedVendorType2[FeedVendorType2["betRadar"] = 1] = "betRadar";
  FeedVendorType2[FeedVendorType2["S2G"] = 6] = "S2G";
  FeedVendorType2[FeedVendorType2["BetBy"] = 7] = "BetBy";
  return FeedVendorType2;
})(FeedVendorType || {});
var BonusFreeBetTypes = /* @__PURE__ */ ((BonusFreeBetTypes2) => {
  BonusFreeBetTypes2[BonusFreeBetTypes2["Full"] = 1] = "Full";
  BonusFreeBetTypes2[BonusFreeBetTypes2["Gain"] = 2] = "Gain";
  BonusFreeBetTypes2[BonusFreeBetTypes2["Base"] = 3] = "Base";
  return BonusFreeBetTypes2;
})(BonusFreeBetTypes || {});
var BetRadarEventType = /* @__PURE__ */ ((BetRadarEventType2) => {
  BetRadarEventType2[BetRadarEventType2["MATCH"] = 0] = "MATCH";
  BetRadarEventType2[BetRadarEventType2["TOURNAMENT"] = 1] = "TOURNAMENT";
  BetRadarEventType2[BetRadarEventType2["SEASON"] = 2] = "SEASON";
  BetRadarEventType2[BetRadarEventType2["STAGE"] = 3] = "STAGE";
  return BetRadarEventType2;
})(BetRadarEventType || {});
var BetSourceType = /* @__PURE__ */ ((BetSourceType2) => {
  BetSourceType2[BetSourceType2["LIST"] = 1] = "LIST";
  BetSourceType2[BetSourceType2["EVENT"] = 2] = "EVENT";
  BetSourceType2[BetSourceType2["ANALYTICS"] = 3] = "ANALYTICS";
  BetSourceType2[BetSourceType2["INCOMING_BETS"] = 4] = "INCOMING_BETS";
  BetSourceType2[BetSourceType2["REAL_TIME_INCOMING_BETS"] = 5] = "REAL_TIME_INCOMING_BETS";
  BetSourceType2[BetSourceType2["ODDS_BOOSTER"] = 6] = "ODDS_BOOSTER";
  BetSourceType2[BetSourceType2["BET_BUILDER"] = 7] = "BET_BUILDER";
  return BetSourceType2;
})(BetSourceType || {});
var BetStateStatus = /* @__PURE__ */ ((BetStateStatus2) => {
  BetStateStatus2[BetStateStatus2["notCalculated"] = 0] = "notCalculated";
  BetStateStatus2[BetStateStatus2["lose"] = 1] = "lose";
  BetStateStatus2[BetStateStatus2["win"] = 2] = "win";
  BetStateStatus2[BetStateStatus2["return"] = 3] = "return";
  BetStateStatus2[BetStateStatus2["vip"] = 4] = "vip";
  BetStateStatus2[BetStateStatus2["rejected"] = 5] = "rejected";
  BetStateStatus2[BetStateStatus2["accepted"] = 6] = "accepted";
  BetStateStatus2[BetStateStatus2["processing"] = 7] = "processing";
  return BetStateStatus2;
})(BetStateStatus || {});
var BetItemType = /* @__PURE__ */ ((BetItemType2) => {
  BetItemType2[BetItemType2["line"] = 0] = "line";
  BetItemType2[BetItemType2["live"] = 1] = "live";
  return BetItemType2;
})(BetItemType || {});
var EventStatus = /* @__PURE__ */ ((EventStatus2) => {
  EventStatus2[EventStatus2["online"] = 2] = "online";
  EventStatus2[EventStatus2["ended"] = 4] = "ended";
  EventStatus2[EventStatus2["line"] = 0] = "line";
  EventStatus2[EventStatus2["stopped"] = 1] = "stopped";
  EventStatus2[EventStatus2["dead"] = 3] = "dead";
  EventStatus2[EventStatus2["closed"] = 5] = "closed";
  EventStatus2[EventStatus2["cancelled"] = 6] = "cancelled";
  return EventStatus2;
})(EventStatus || {});
var EventSectionModifiers = /* @__PURE__ */ ((EventSectionModifiers2) => {
  EventSectionModifiers2["blue"] = "c_blue";
  EventSectionModifiers2["red"] = "c_red";
  EventSectionModifiers2["base"] = "";
  return EventSectionModifiers2;
})(EventSectionModifiers || {});
const EventStoppedStatus = [
  1,
  3,
  4,
  5,
  6
  /* cancelled */
];
const EventClosedStatus = [
  4,
  5,
  3
  /* dead */
];
const mappedBetRadarEvenTypes = {
  [
    "event-closed"
    /* close */
  ]: 5,
  [
    "event-start-live"
    /* startLive */
  ]: 2,
  [
    "event-stopped"
    /* eventStopped */
  ]: 1,
  [
    "event-ended"
    /* ended */
  ]: 4
  /* ended */
};
var SportPeriodFilter = /* @__PURE__ */ ((SportPeriodFilter2) => {
  SportPeriodFilter2["48h"] = "7";
  SportPeriodFilter2["24h"] = "5";
  SportPeriodFilter2["12h"] = "4";
  SportPeriodFilter2["6h"] = "3";
  SportPeriodFilter2["3h"] = "2";
  SportPeriodFilter2["1h"] = "1";
  SportPeriodFilter2["30min"] = "6";
  SportPeriodFilter2["all"] = "0";
  return SportPeriodFilter2;
})(SportPeriodFilter || {});
var OutcomeTypes = /* @__PURE__ */ ((OutcomeTypes2) => {
  OutcomeTypes2[OutcomeTypes2["normal"] = 1] = "normal";
  OutcomeTypes2[OutcomeTypes2["variant"] = 2] = "variant";
  OutcomeTypes2[OutcomeTypes2["player"] = 3] = "player";
  OutcomeTypes2[OutcomeTypes2["competitors"] = 5] = "competitors";
  return OutcomeTypes2;
})(OutcomeTypes || {});
var SportTypes = /* @__PURE__ */ ((SportTypes2) => {
  SportTypes2["football"] = "football";
  SportTypes2["basketBall"] = "basketball";
  SportTypes2["tennis"] = "tennis";
  SportTypes2["volleybal"] = "volleybal";
  SportTypes2["snooker"] = "snooker";
  SportTypes2["tableTennis"] = "tabletennis";
  SportTypes2["badminton"] = "badminton";
  SportTypes2["baseball"] = "baseball";
  SportTypes2["americanFootbal"] = "americanfootbal";
  SportTypes2["darts"] = "darts";
  SportTypes2["esports"] = "esports";
  SportTypes2["F1"] = "f1";
  SportTypes2["cycling"] = "cycling";
  return SportTypes2;
})(SportTypes || {});
var BoostedOddsStatuses = /* @__PURE__ */ ((BoostedOddsStatuses2) => {
  BoostedOddsStatuses2[BoostedOddsStatuses2["new"] = 1] = "new";
  BoostedOddsStatuses2[BoostedOddsStatuses2["active"] = 2] = "active";
  BoostedOddsStatuses2[BoostedOddsStatuses2["deactivated"] = 3] = "deactivated";
  return BoostedOddsStatuses2;
})(BoostedOddsStatuses || {});
var SportConfigSportViewTypes = /* @__PURE__ */ ((SportConfigSportViewTypes2) => {
  SportConfigSportViewTypes2["CA"] = "CA";
  SportConfigSportViewTypes2["EU"] = "EU";
  return SportConfigSportViewTypes2;
})(SportConfigSportViewTypes || {});
var SportConfigTemplates = /* @__PURE__ */ ((SportConfigTemplates2) => {
  SportConfigTemplates2["base"] = "base";
  SportConfigTemplates2[SportConfigTemplates2["live"] = 0] = "live";
  SportConfigTemplates2[SportConfigTemplates2["line"] = 1] = "line";
  return SportConfigTemplates2;
})(SportConfigTemplates || {});
var EventBreakPoint = /* @__PURE__ */ ((EventBreakPoint2) => {
  EventBreakPoint2["full"] = "full";
  EventBreakPoint2["step1"] = "step1";
  EventBreakPoint2["step2"] = "step2";
  EventBreakPoint2["step3"] = "step3";
  return EventBreakPoint2;
})(EventBreakPoint || {});
var SportGetParamsRelations = /* @__PURE__ */ ((SportGetParamsRelations2) => {
  SportGetParamsRelations2["league"] = "league";
  SportGetParamsRelations2["odds"] = "odds";
  SportGetParamsRelations2["result"] = "result";
  SportGetParamsRelations2["team"] = "competitors";
  SportGetParamsRelations2["players"] = "players";
  SportGetParamsRelations2["variants"] = "variants";
  SportGetParamsRelations2["sportCategories"] = "sportCategories";
  SportGetParamsRelations2["withMarketsCount"] = "withMarketsCount";
  SportGetParamsRelations2["broadcasts"] = "broadcasts";
  SportGetParamsRelations2["statistics"] = "statistics";
  SportGetParamsRelations2["additionalInfo"] = "additionalInfo";
  SportGetParamsRelations2["tips"] = "tips";
  SportGetParamsRelations2["sport"] = "sport";
  SportGetParamsRelations2["marketOrder"] = "marketOrder";
  SportGetParamsRelations2["competitors"] = "competitors";
  SportGetParamsRelations2["pinnedEvents"] = "pinnedEvents";
  SportGetParamsRelations2["events"] = "events";
  return SportGetParamsRelations2;
})(SportGetParamsRelations || {});
var ForecastTypes = /* @__PURE__ */ ((ForecastTypes2) => {
  ForecastTypes2[ForecastTypes2["pending"] = 3] = "pending";
  ForecastTypes2[ForecastTypes2["lost"] = 2] = "lost";
  ForecastTypes2[ForecastTypes2["won"] = 1] = "won";
  ForecastTypes2[ForecastTypes2["all"] = 0] = "all";
  return ForecastTypes2;
})(ForecastTypes || {});
var Sections = /* @__PURE__ */ ((Sections2) => {
  Sections2["all"] = "all";
  Sections2["live"] = "live";
  Sections2["line"] = "prematch";
  return Sections2;
})(Sections || {});
const CricketMatchStatusIdsTeamHome = [501, 503, 506];
const CricketMatchStatusIdsTeamAway = [502, 504, 507];
const CricketMatchStatusIds = [
  ...CricketMatchStatusIdsTeamHome,
  ...CricketMatchStatusIdsTeamAway
];
var OddsBoosterSocketTypes = /* @__PURE__ */ ((OddsBoosterSocketTypes2) => {
  OddsBoosterSocketTypes2["bannersUpdate"] = "boosted-odds-banner";
  OddsBoosterSocketTypes2["oddsUpdate"] = "boosted-odds";
  return OddsBoosterSocketTypes2;
})(OddsBoosterSocketTypes || {});
var RealTimeIncomingBetsSocketTypes = /* @__PURE__ */ ((RealTimeIncomingBetsSocketTypes2) => {
  RealTimeIncomingBetsSocketTypes2["updateBets"] = "incoming-bets";
  return RealTimeIncomingBetsSocketTypes2;
})(RealTimeIncomingBetsSocketTypes || {});
var HasLive = /* @__PURE__ */ ((HasLive2) => {
  HasLive2["noLive"] = "0";
  HasLive2["hasLive"] = "1";
  return HasLive2;
})(HasLive || {});
var BroadcastType = /* @__PURE__ */ ((BroadcastType2) => {
  BroadcastType2["hls"] = "hls";
  BroadcastType2["iframe"] = "iframe";
  return BroadcastType2;
})(BroadcastType || {});
var AdditionalCoverageSource = /* @__PURE__ */ ((AdditionalCoverageSource2) => {
  AdditionalCoverageSource2["tv"] = "tv";
  AdditionalCoverageSource2["venue"] = "venue";
  return AdditionalCoverageSource2;
})(AdditionalCoverageSource || {});
var EventTeamsModifiers = /* @__PURE__ */ ((EventTeamsModifiers2) => {
  EventTeamsModifiers2["big"] = "big";
  EventTeamsModifiers2["comma"] = "comma";
  return EventTeamsModifiers2;
})(EventTeamsModifiers || {});
const defaultPrematchFilter = "7";
export {
  AdditionalCoverageSource,
  BetItemType,
  BetRadarEntityStatus,
  BetRadarEventType,
  BetRadarSocketTypes,
  BetSourceType,
  BetStateStatus,
  BonusFreeBetTypes,
  BoostedOddsStatuses,
  BroadcastType,
  CricketMatchStatusIds,
  CricketMatchStatusIdsTeamAway,
  CricketMatchStatusIdsTeamHome,
  EventBreakPoint,
  EventClosedStatus,
  EventSectionModifiers,
  EventStatus,
  EventStoppedStatus,
  EventTeamsModifiers,
  EventTypesMap,
  FeedVendorType,
  ForecastTypes,
  HasLive,
  LeaguePageSections,
  OddsBoosterSocketTypes,
  OutcomeTypes,
  RealTimeIncomingBetsSocketTypes,
  RoundTypes,
  SearchTabs,
  Sections,
  SportConfigSportViewTypes,
  SportConfigTemplates,
  SportGetParamsRelations,
  SportPeriodFilter,
  SportType,
  SportTypes,
  SurfaceVariants,
  defaultPrematchFilter,
  mappedBetRadarEvenTypes
};
